import { render, staticRenderFns } from "./StatusSolicitacaoSaque.vue?vue&type=template&id=0aef71ff&scoped=true"
import script from "./StatusSolicitacaoSaque.vue?vue&type=script&lang=js"
export * from "./StatusSolicitacaoSaque.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aef71ff",
  null
  
)

export default component.exports